export default __webpack_public_path__ + "static/media/newMain-bg2.06f4c229.png";